/**
 * show screenshot component
 * */
import React, {useEffect, useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {EffectFade, Navigation} from "swiper";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/effect-fade/effect-fade.min.css'
import callPeerRemoteModule from "../../../../core/utils/callPeerRemoteModule";
import useTakeScreenShot from "../../../hooks/core/useTakeScreenShot";


SwiperCore.use([Navigation, EffectFade]);

const ScreenShot = () => {
  const {connectMode, screenShot, screenShotActiveIndex, screenShotReady, summaryImageElement} = useTakeScreenShot();

  const [swiperLoaded, setSwiperLoaded] = useState(false);
  const [swiper, setSwiper] = useState(null);

  const slideChangeHandler = async(e) => {
    if (connectMode === "remote") {
      const peer = await callPeerRemoteModule(connectMode);
      peer && peer.conn.sendData("dispatch", {
        action: "summaryAction",
        func: "setScreenShotActiveIndex",
        payload: e.realIndex
      });
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setSwiperLoaded(true);
    }, 100); // 100ms 지연

    return () => clearTimeout(timer);
  }, []);



  const slideParams = {
    navigation: connectMode !== "mediaWall",
    speed: 800,
    loop: connectMode === "web",
    loopedSlides: screenShot && screenShot.length,
    initialSlide: 0,
    onSlideChangeTransitionStart: slideChangeHandler,
    onSwiper: setSwiper
  }


  useEffect(() => {
    if (swiper && connectMode === "mediaWall") {
      swiper.slideToLoop(screenShotActiveIndex);
    }
  }, [screenShotActiveIndex])



  return (
    <div className={"summary-image"} ref={summaryImageElement}>
      {!swiperLoaded ? (
        <div className={"loadingView"} style={{display: "block"}}>
          <div className={"spinner"}/>
        </div>
      ) : (
        <>
          {!screenShotReady ? (
            <div className={"loadingView"} style={{display: "block"}}>
              <div className={"spinner"}/>
            </div>
          ) : (
            <Swiper {...slideParams}>
              {screenShot && screenShot.map(item => (
                <SwiperSlide
                  key={item.id}
                  style={{backgroundImage: screenShotReady ? `url(${item.img})` : ""}}
                />
              ))}
            </Swiper>
          )}
        </>
      )}
    </div>)
}
export default ScreenShot;
